import { render, staticRenderFns } from "./SidebaVariantMod.vue?vue&type=template&id=7e1b7d73"
import script from "./SidebaVariantMod.vue?vue&type=script&lang=js"
export * from "./SidebaVariantMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports